// import React, { useState, useEffect } from 'react';
// import { ListGroup } from 'react-bootstrap';
// import { Link, useLocation } from 'react-router-dom';

// import navigation from '../../../menu-items';
// import { BASE_TITLE } from '../../../config/constant';

// const Breadcrumb = () => {
//   const location = useLocation();

//   const [main, setMain] = useState([]);
//   const [item, setItem] = useState([]);

//   useEffect(() => {
//     navigation.items.map((item, index) => {
//       if (item.type && item.type === 'group') {
//         getCollapse(item, index);
//       }
//       return false;
//     });
//   });

//   const getCollapse = (item, index) => {
//     if (item.children) {
//       item.children.filter((collapse) => {
//         if (collapse.type && collapse.type === 'collapse') {
//           getCollapse(collapse, index);
//         } else if (collapse.type && collapse.type === 'item') {
//           if (location.pathname === collapse.url) {
//             setMain(item);
//             setItem(collapse);
//           }
//         }
//         return false;
//       });
//     }
//   };

//   let mainContent, itemContent;
//   let breadcrumbContent = '';
//   let title = '';

//   console.log(breadcrumbContent ,"breadcrumbContent" ,location)

//   if (main && main.type === 'collapse') {
//     mainContent = (
//       <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
//         <Link to="#">{main.title}</Link>
//       </ListGroup.Item>
//     );
//   }

//   if (item && item.type === 'item') {
//     title = item.title;
//     itemContent = (
//       <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
//         <Link to="#">{title}</Link>
//       </ListGroup.Item>
//     );

//     if (item.breadcrumbs !== false) {
//       breadcrumbContent = (
//         <div className="page-header">
//           <div className="page-block">
//             <div className="row align-items-center">
//               <div className="col-md-12">
//                 <div className="page-header-title">
//                   <h5 className="m-b-10">{title}</h5>
//                 </div>
//                 <ListGroup as="ul" bsPrefix=" " className="breadcrumb">
//                   <ListGroup.Item as="li" bsPrefix=" " className="breadcrumb-item">
//                     <Link to="/">
//                       <i className="feather icon-home" />
//                     </Link>
//                   </ListGroup.Item>
//                   {mainContent}
//                   {itemContent}
//                 </ListGroup>
//               </div>
//             </div>
//           </div>
//         </div>
//       );
//     }

//     document.title = title + BASE_TITLE;
//   }

//   return <React.Fragment>{breadcrumbContent}</React.Fragment>;
// };

// export default Breadcrumb;

import React, { useState, useEffect } from 'react';
import { ListGroup } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { getSessionStorage } from '../../../utils/helpers';
// import navigation from '../../../menu-items';
// import { BASE_TITLE } from '../../../config/constant';

const Breadcrumb = (props) => {
  const permissionLevel  = getSessionStorage("PERMISSION_LEVEL");
  const location = useLocation();
  const [main, setMain] = useState([]);
  function insertSpaceBeforeCaps(str) {
    let result = '';
    for (let i = 0; i < str.length; i++) {
      if (i > 0 && str[i] === str[i].toUpperCase()) {
        result += ' ' + str[i];
      } else {
        result += str[i];
      }
    }
    return result;
  }

  useEffect(() => {
    if (location.pathname.includes('app/dashboard/default')) {
      // setMain(["dashboard"]);
      props.currentURLFunction("dashboard")
    } else {
      let tempLocation = location.pathname.split('/').filter((item) => item !== ''); // Remove empty strings from the array
      if(tempLocation.length>2 && tempLocation.includes('QuestionBankReview')){
        tempLocation[2] = 'QBReview';
      }
      setMain(tempLocation);
      props.currentURLFunction(tempLocation)
    }
  }, [location.pathname]);

  return (
    <React.Fragment>
      <div className="page-header">
        <div className="page-block">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="page-header-title">
                {/* <h5 className="m-b-10">{BASE_TITLE}</h5> */}
                {/* Use BASE_TITLE for the main title */}
              </div>
              {permissionLevel !='external'&&(<div className="breadcrumb" style={{ display: 'flex' }}>
                {main.length > 0 && (
                  <ListGroup.Item as="li" bsPrefix="" className="breadcrumb-item">
                    <Link to="/">
                      <i className="feather icon-home" />
                    </Link>
                  </ListGroup.Item>
                )}
                {main.map((item, index) => (
                  <ListGroup.Item key={index} as="li" bsPrefix="" className="breadcrumb-item text-capitalize">
                    {index !== main.length - 1 ? (
                      <Link to={`/${item}`}>{insertSpaceBeforeCaps(item)}</Link> // Link to each breadcrumb item except the last one
                    ) : (
                      insertSpaceBeforeCaps(item) // Display the last breadcrumb item without a link
                    )}
                  </ListGroup.Item>
                ))}
              </div>)}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Breadcrumb;
